import { useFormContext } from "react-hook-form";

import { ConfigFieldsetCard as FieldsetCard } from "src/connections/config/FieldsetCard";
import { InboundWebhookSecretField } from "src/connections/config/inboundWebhook/InboundWebhookSecretField";
import { AuthMethodProps } from "src/connections/config/inboundWebhook/types";
import { isFieldErrored } from "src/connections/config/isFieldErrored";
import { InboundWebhookConnectionConfigInputs } from "src/connections/types";

export const InboundWebhookHMACSyntageAuthFieldset: React.FC<
  AuthMethodProps
> = ({ environment }) => {
  const {
    formState: { errors },
  } = useFormContext<InboundWebhookConnectionConfigInputs>();
  const configField = `${environment}Config` as const;

  const settingsErrors = errors?.[configField]?.webhookHMACSyntageConfig;
  return (
    <FieldsetCard className="last:mb-0">
      <InboundWebhookSecretField
        dataLoc={`${environment}-webhook-hmac-syntage-signing-key`}
        environment={environment}
        helpText="The secret key used to generate the HMAC signature. Ensure it matches the value found in your Syntage Dashboard."
        isErrored={isFieldErrored(settingsErrors?.signingKey, "value")}
        secretConfigField="webhookHMACSyntageConfig.signingKey"
        secretName="Webhook secret"
        isRequired
      />
    </FieldsetCard>
  );
};
